import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b6578ece"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-u466" }, null, -1))
const _hoisted_3 = { class: "list" }
const _hoisted_4 = { class: "part" }
const _hoisted_5 = { class: "part-title" }
const _hoisted_6 = { class: "part-list" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "name c-primary" }
const _hoisted_9 = { class: "line1" }
const _hoisted_10 = {
  key: 0,
  class: "live orange"
}
const _hoisted_11 = {
  key: 1,
  class: "live red"
}
const _hoisted_12 = {
  key: 2,
  class: "live gray"
}
const _hoisted_13 = {
  key: 3,
  class: "live blue"
}
const _hoisted_14 = { class: "desc c-thirdary" }
const _hoisted_15 = { class: "part" }
const _hoisted_16 = { class: "part-title" }
const _hoisted_17 = { class: "part-list" }
const _hoisted_18 = { class: "info" }
const _hoisted_19 = { class: "name c-primary" }
const _hoisted_20 = { class: "line1" }
const _hoisted_21 = {
  key: 0,
  class: "part"
}
const _hoisted_22 = { class: "part-title c-secondary" }
const _hoisted_23 = { class: "part-list" }
const _hoisted_24 = { class: "info" }
const _hoisted_25 = { class: "name c-primary" }
const _hoisted_26 = { class: "line1" }

import home from '@/store/channels/home';
import i18, { State as I18State } from '@/store/i18';
import * as filters from '@/views/filters';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const route = useRoute()
const store = useStore()
const leftData = computed(() => store.state[home.name].left)

const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].live)
const channelLang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].channel)

function isLive(id: number) {
    return route.path.startsWith('/lives/') && route.params.id == id + ''
}

function isShort(tag: string) {
    return route.path.startsWith('/shorts/index.html') && route.query.tag == tag
}

function isChannel(id: number) {
    return route.path.startsWith('/channels/detail/') && route.params.id == id + ''
}

function onHome() {
    router.push({ name: 'lives' })
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "title",
      onClick: onHome
    }, [
      _hoisted_2,
      _createElementVNode("a", null, _toDisplayString(_unref(lang).channel), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(channelLang).lives), 1),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(leftData).lives, (item) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              class: _normalizeClass(["item", { on: isLive(item.id) }]),
              to: `/lives/${item.id}/index.html`
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "poster",
                  style: _normalizeStyle(_unref(filters).bg(item.thumb))
                }, null, 4),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(item.title), 1),
                    (item.push_status == 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(lang).live_wait), 1))
                      : _createCommentVNode("", true),
                    (item.push_status == 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(lang).live_play), 1))
                      : _createCommentVNode("", true),
                    (item.push_status == 2)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(lang).live_end), 1))
                      : _createCommentVNode("", true),
                    (item.push_status == 3)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(lang).live_replay), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(filters).datetime(item.starttime)), 1)
                ])
              ]),
              _: 2
            }, 1032, ["class", "to"]))
          }), 256))
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(channelLang).shorts), 1),
        _createElementVNode("div", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(leftData).tags, (item) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              class: _normalizeClass(["item", { on: isShort(item.tag) }]),
              to: `/shorts/index.html?tag=${item.tag}`
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "poster",
                  style: _normalizeStyle(_unref(filters).bg(item.thumb))
                }, null, 4),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, " #" + _toDisplayString(item.tag) + "# ", 1)
                  ])
                ])
              ]),
              _: 2
            }, 1032, ["class", "to"]))
          }), 256))
        ])
      ]),
      (_unref(leftData).channels.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(channelLang).myChannels), 1),
            _createElementVNode("div", _hoisted_23, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(leftData).channels, (item) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  class: _normalizeClass(["item", { on: isChannel(item.id) }]),
                  to: `/channels/detail/${item.id}.html`
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "poster",
                      style: _normalizeStyle(_unref(filters).bg(item.thumb))
                    }, null, 4),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("span", _hoisted_26, _toDisplayString(item.title), 1)
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["class", "to"]))
              }), 256))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})